// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from '../../components/Utils/AppLogoImg';
import Loader from '../../components/Utils/Loader';

import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");

const ConfiguredApplicationsList = (appsParam) => {

  useEffect(() => {           
    initialConfigCommonJS.CargarCuentasAplicacionesRegistradas(appsParam.setAvailableApps)           
  },[appsParam.availableApps]);

  function seleccionarAplicacion(aplicacion){   
    appsParam.setAppToRegister(aplicacion)             
    initialConfigCommonJS.cargarListaDispositivos(aplicacion, appsParam.setAvailableDevices)        
    initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoDispositivosDisponibles","noUpdate")
  }

  const AppsList = (componentParam) => {     
        
    const listApps = componentParam.appsList.map((app) =>
      <li id={"CONF-"+app.Aplicacion} key={app.Aplicacion} className=" hidden">          
        <button className="selector icon-wrapper no-icon" onClick={() => seleccionarAplicacion(app.Aplicacion)}>
          <figure className="avatar size-m"><AppLogoImg aplicacion={app.Aplicacion}/></figure>
          <div className="content">
            <h1 className="brand-name">{initialConfigCommonJS.obtenerLiteralAtributo(app.Aplicacion)}</h1>
          </div>            
        </button>                    
      </li> 
    );    
    return (
        <ul id="listadoAplicacionesConfiguradasParaEstePaso">{listApps}</ul>
    )    
  }

  return (          
    <>
    <header>
      <figure className="avatar size-m orange"><span className="material-icon">cable</span></figure>
      <h1 className="headline-03">Seleccionar aplicación</h1>
    </header>
    <section className="brands">
      <section className="brands-list">  

        <AppsList appsList={appsParam.appsList} />
        
        <div id="mensajeSinAplicacionesCompatibles" className="message medium empty hidden"> 
          <picture>
            <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
            <img src={imgNoResultsDark} alt=""/>
          </picture>
          <h1 className="title">No hay aplicaciones registradas compatibles para controlar este dispositivo.</h1>
        </div>

      </section>                          
      <ul className="actions vertical">
        <li><button id="botonAñadirAplicacion" className="button primary" onClick={() => initialConfigCommonJS.navegarFlujoAplicacionesDispositivos("listadoAplicacionesDisponibles", appsParam.setSelecteDeviceToConfigure)}>Añadir aplicación</button></li>
      </ul>

    </section>
    <Loader Id="loaderAppsConfiguradas" Mensaje=""/>
    </> 
  )
}

export default ConfiguredApplicationsList